import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { getMyCart, updateCartEventType } from "../../../../utils/APIs/cartApis";
import { HOURLY_SHOOT_CATEGORY_OPTIONS } from "../hourlyCategoryOptions";
import {
    getCachedHourlyEventType,
    notifyHourlyEventTypeChange,
    setCachedHourlyEventType,
} from "../hourlyCartCategory";

const HourlyCategorySelect = ({ className = "" }) => {
    const [selectedCategory, setSelectedCategory] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        (async () => {
            try {
                const res = await getMyCart();
                const saved =
                    res?.data?.data?.eventType || getCachedHourlyEventType();
                if (saved) {
                    setSelectedCategory(saved);
                    setCachedHourlyEventType(saved);
                }
            } catch (err) {
                const cached = getCachedHourlyEventType();
                if (cached) setSelectedCategory(cached);
                console.error("Failed to load cart category", err);
            }
        })();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = async (value) => {
        const previous = selectedCategory;
        setSelectedCategory(value);
        setIsOpen(false);
        try {
            await updateCartEventType(value || "");
            setCachedHourlyEventType(value || "");
            notifyHourlyEventTypeChange(value || "");
        } catch (err) {
            setSelectedCategory(previous);
            console.error("Failed to save cart category", err);
            toast.error("Could not save category. Please try again.");
        }
    };

    const selectedLabel =
        HOURLY_SHOOT_CATEGORY_OPTIONS.find((opt) => opt.value === selectedCategory)
            ?.label || "Select Category";

    return (
        <div className={`custom-hourly-select ${className}`} ref={dropdownRef} style={{ position: "relative" }}>
            <div 
                className="custom-hourly-select-btn"
                onClick={() => setIsOpen(!isOpen)}
                style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'start',
                    width: '100%',
                    height: '100%'
                }}
            >
                <span>{selectedLabel}</span>
                {/* Arrow is handled by background-image in the existing CSS class */}
            </div>

            {isOpen && (
                <div className="custom-hourly-select-menu" style={{
                    position: "absolute",
                    top: "calc(100% + 4px)",
                    left: 0,
                    width: "100%",
                    maxHeight: "250px",
                    overflowY: "auto",
                    backgroundColor: "var(--primary-color)",
                    border: "2px solid var(--primary-color)",
                    borderRadius: "8px",
                    zIndex: 999,
                    padding: "4px 0",
                    boxShadow: "0 4px 12px rgba(74, 51, 38, 0.1)"
                }}>

                    {HOURLY_SHOOT_CATEGORY_OPTIONS.map((opt) => (
                        <div 
                            key={opt.value}
                            className="custom-hourly-select-item"
                            onClick={() => handleSelect(opt.value)}
                            style={{
                                padding: "10px 20px",
                                color: "#ffffff",
                                cursor: "pointer",
                                fontSize: "16px",
                                fontFamily: "var(--primary-font-family, serif)",
                                transition: "all 0.2s",
                                textAlign: "left"
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "var(--tertiary-color)"; e.currentTarget.style.color = "var(--primary-color)"; }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = "#ffffff"; }}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HourlyCategorySelect;
